// Sword Icon for login - Medieval sword
export const SwordIcon = ({ isLoggedIn, size = 36 }) => {
  const bladeColor1 = "#d1d5db"
  const bladeColor2 = "#6b7280"
  const bladeColor3 = "#4b5563"
  const gemColor1 = isLoggedIn ? "#22c55e" : "#dc2626"
  const gemColor2 = isLoggedIn ? "#16a34a" : "#b91c1c"
  const gemColor3 = isLoggedIn ? "#15803d" : "#991b1b"
  const glowColor = isLoggedIn ? "#86efac" : "#fca5a5"
  
  return (
    <svg viewBox="0 0 40 40" width={size} height={size} fill="none">
      <defs>
        <linearGradient id={`loginBlade-${isLoggedIn}`} x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#9ca3af"/>
          <stop offset="25%" stopColor="#d1d5db"/>
          <stop offset="50%" stopColor="#f3f4f6"/>
          <stop offset="75%" stopColor="#d1d5db"/>
          <stop offset="100%" stopColor="#6b7280"/>
        </linearGradient>
        <linearGradient id={`loginGold-${isLoggedIn}`} x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#fcd34d"/>
          <stop offset="50%" stopColor="#fbbf24"/>
          <stop offset="100%" stopColor="#f59e0b"/>
        </linearGradient>
        <linearGradient id={`loginGem-${isLoggedIn}`} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={gemColor1}/>
          <stop offset="50%" stopColor={gemColor2}/>
          <stop offset="100%" stopColor={gemColor3}/>
        </linearGradient>
        <linearGradient id={`loginLeather-${isLoggedIn}`} x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#78350f"/>
          <stop offset="50%" stopColor="#92400e"/>
          <stop offset="100%" stopColor="#78350f"/>
        </linearGradient>
        <linearGradient id={`loginBronze-${isLoggedIn}`} x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#d97706"/>
          <stop offset="50%" stopColor="#b45309"/>
          <stop offset="100%" stopColor="#92400e"/>
        </linearGradient>
      </defs>
      
      <g>
        {/* Lâmina de aço */}
        <path d="M20 3 L22 4 L22.5 22 L20 24 L17.5 22 L18 4 Z" 
              fill={`url(#loginBlade-${isLoggedIn})`} stroke="#4b5563" strokeWidth="0.5"/>
        
        {/* Canal de sangue */}
        <path d="M20 5 L20 22" stroke="#6b7280" strokeWidth="0.7" opacity="0.6"/>
        
        {/* Brilho metálico */}
        <path d="M18.8 4.5 L18.8 22" stroke="#f9fafb" strokeWidth="0.4" opacity="0.7"/>
        <path d="M21.2 4.5 L21.2 22" stroke="#9ca3af" strokeWidth="0.3" opacity="0.5"/>
        
        {/* Entalhes medievais */}
        <g opacity="0.4">
          <line x1="19" y1="8" x2="21" y2="8" stroke="#4b5563" strokeWidth="0.3"/>
          <line x1="19.3" y1="9" x2="20.7" y2="9" stroke="#4b5563" strokeWidth="0.3"/>
          
          <line x1="19" y1="13" x2="21" y2="13" stroke="#4b5563" strokeWidth="0.3"/>
          <line x1="19.3" y1="14" x2="20.7" y2="14" stroke="#4b5563" strokeWidth="0.3"/>
          
          <line x1="19" y1="18" x2="21" y2="18" stroke="#4b5563" strokeWidth="0.3"/>
          <line x1="19.3" y1="19" x2="20.7" y2="19" stroke="#4b5563" strokeWidth="0.3"/>
        </g>
        
        {/* Ponta afiada */}
        <path d="M17.5 22 L20 27 L22.5 22" fill={`url(#loginBlade-${isLoggedIn})`} stroke="#4b5563" strokeWidth="0.5"/>
        <path d="M20 23 L20 27" stroke="#e5e7eb" strokeWidth="0.4" opacity="0.7"/>
        
        {/* Guarda medieval em cruz */}
        <ellipse cx="20" cy="22.5" rx="6" ry="1.3" fill={`url(#loginBronze-${isLoggedIn})`} 
                 stroke="#78350f" strokeWidth="0.4"/>
        <rect x="14" y="22" width="12" height="1.8" rx="0.6" 
              fill={`url(#loginGold-${isLoggedIn})`} stroke="#92400e" strokeWidth="0.4"/>
        
        {/* Pontas da guarda */}
        <path d="M14 22.5 L12 22 L12 23 L14 22.5" fill={`url(#loginBronze-${isLoggedIn})`} stroke="#78350f" strokeWidth="0.3"/>
        <path d="M26 22.5 L28 22 L28 23 L26 22.5" fill={`url(#loginBronze-${isLoggedIn})`} stroke="#78350f" strokeWidth="0.3"/>
        
        {/* Gemas nas pontas (verde se logado, vermelho se não) */}
        <circle cx="12" cy="22.5" r="0.65" fill={`url(#loginGem-${isLoggedIn})`}/>
        <circle cx="11.8" cy="22.3" r="0.3" fill={glowColor} opacity="0.7"/>
        <circle cx="28" cy="22.5" r="0.65" fill={`url(#loginGem-${isLoggedIn})`}/>
        <circle cx="27.8" cy="22.3" r="0.3" fill={glowColor} opacity="0.7"/>
        
        {/* Detalhes entalhados */}
        <g opacity="0.5">
          <line x1="15" y1="22.7" x2="25" y2="22.7" stroke="#fbbf24" strokeWidth="0.25"/>
          <line x1="14.5" y1="23" x2="25.5" y2="23" stroke="#92400e" strokeWidth="0.2"/>
        </g>
        
        {/* Cabo de couro */}
        <rect x="18.5" y="23.8" width="3" height="7" rx="0.4" 
              fill={`url(#loginLeather-${isLoggedIn})`} stroke="#451a03" strokeWidth="0.3"/>
        
        {/* Amarrações de couro */}
        <g opacity="0.7">
          <path d="M18 25 L22 25.2" stroke="#d97706" strokeWidth="0.35"/>
          <path d="M18 26.3 L22 26.5" stroke="#d97706" strokeWidth="0.35"/>
          <path d="M18 27.6 L22 27.8" stroke="#d97706" strokeWidth="0.35"/>
          <path d="M18 28.9 L22 29.1" stroke="#d97706" strokeWidth="0.35"/>
          <path d="M18 30.2 L22 30.4" stroke="#d97706" strokeWidth="0.35"/>
        </g>
        
        {/* Textura de couro */}
        <g opacity="0.25">
          <line x1="19" y1="24" x2="19" y2="30.5" stroke="#92400e" strokeWidth="0.15"/>
          <line x1="19.5" y1="24" x2="19.5" y2="30.5" stroke="#92400e" strokeWidth="0.15"/>
          <line x1="20.5" y1="24" x2="20.5" y2="30.5" stroke="#92400e" strokeWidth="0.15"/>
          <line x1="21" y1="24" x2="21" y2="30.5" stroke="#92400e" strokeWidth="0.15"/>
        </g>
        
        {/* Pomo medieval */}
        <ellipse cx="20" cy="31.5" rx="2.2" ry="1.6" fill={`url(#loginGold-${isLoggedIn})`} 
                 stroke="#92400e" strokeWidth="0.4"/>
        <ellipse cx="20" cy="31.3" rx="1.9" ry="1.3" fill="#fbbf24" opacity="0.3"/>
        
        {/* Gema central no pomo (verde se logado, vermelho se não) */}
        <ellipse cx="20" cy="31.5" rx="1" ry="0.8" fill={`url(#loginGem-${isLoggedIn})`} 
                 stroke={gemColor3} strokeWidth="0.3"/>
        <ellipse cx="19.7" cy="31.2" rx="0.4" ry="0.35" fill={glowColor} opacity="0.8"/>
        
        {/* Detalhes entalhados no pomo */}
        <g opacity="0.5">
          <circle cx="18.2" cy="31.5" r="0.35" fill="#d97706"/>
          <circle cx="21.8" cy="31.5" r="0.35" fill="#d97706"/>
          <circle cx="20" cy="30.3" r="0.3" fill="#d97706"/>
          <circle cx="20" cy="32.6" r="0.3" fill="#d97706"/>
        </g>
      </g>
    </svg>
  )
}
